module.exports = __webpack_public_path__ + "img/LOGO.a6294d4c.png";